import "./src/plugins/bootstrap/bootstrap.min.css"

import "prismjs/themes/prism.css"
import "prismjs/themes/prism-okaidia.css"
import "./src/assets/style.scss"

import "@fortawesome/fontawesome-svg-core/styles.css"
